<div class="content-layout" [brightsideWebFb]="{ event_name: 'credit_kba_welcome_shown' }">
  <div></div>
  <bw-action-article-legacy *ngIf="hasGivenName">
    <ui-nav-exit-back
      *ngIf="!pageFromFullLayout"
      back-action-top
      [trackingDetail]="{ event_name: 'credit_kba_welcome_dismissed' }"
      (exitActionHandler)="handleCancelCtaClick()"
    ></ui-nav-exit-back>
    <ui-nav-exit-back
      *ngIf="pageFromFullLayout"
      back-action-bottom
      [trackingDetail]="{ event_name: 'credit_kba_welcome_dismissed' }"
      (exitActionHandler)="handleCancelCtaClick()"
    ></ui-nav-exit-back>

    <div header-title class="mb-md">
      <typography-legacy title-medium>
        {{ 'KBA_WELCOME_TITLE' | translate: { name: givenName } }}
      </typography-legacy>
    </div>

    <div content-section>
      <div class="flex-column space-center mb-xl">
        <img src="../assets/security_badge.png"  class="mb-md" />
        <p title-medium class="mb-sm">{{ 'KBA_WELCOME_TITLE' | translate }}</p>
        <typography-legacy text-large-regular color="var(--secondary-text)">
          <p class="center" style="max-width: 432px; white-space: pre-wrap">
            {{ 'KBA_WELCOME_DESC' | translate }}
          </p>
        </typography-legacy>
      </div>
    </div>

    <div footer-actions class="flex-row flex-item-flexible space-between">
      <div></div>
      <div class="flex-row row-reverse">
        <button
          bw-button-legacy
          type="submit"
          [brightsideWebFb]="{ event_name: 'credit_kba_welcome_tapped', action: 'click' }"
          [processing]="processing"
          (click)="handleCtaClick()"
        >
          {{ 'BUTTON_CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </bw-action-article-legacy>
</div>
